import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Icon from '../Icon/Icon';
import './CalendarHeader.css';

const CalendarHeaderWrapper = styled.div`
  display: block;
  text-align: center;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
  width: 340px;
  height: 35px;
  background-color: #f4f8f9;
  
  @media(min-width: 375px) {
    width: 346px;
  }

  @media(min-width: 800px) {
    width: ${props => props.isClient ? '800px' : '489px'};  
    height: 44px;
  }
`;

const Arrow = styled.button`
  width: 28px;
  height: 24px;
  border-radius: 4px;
  border: solid 1px #d6d6d6;
  display: inline-block;
  position: relative;
  cursor: pointer;
  background:transparent;
  @media(min-width: 800px) {
    width: 36px;
    height: 30px;
  }
`;

const CalendarMonth = styled.div`
  font-size: 12px;
  text-align: center;
  color: #4a4a4a;  
  font-weight: bold;
  margin: 8px 16px;
  display:inline-block
  @media(min-width: 800px) {
    font-size: 14px;
  }
`;

const CalendarHeader = (props) => {
  return (
    <CalendarHeaderWrapper isClient={props.isClientView}>

      <Arrow
        onClick={props.handlePreviousMonth}
        title="Previous Month"
      >
        <Icon icon="calendar-prev-month-icon" />
      </Arrow>
      <CalendarMonth className="calendar-month-year">
        {props.monthYear}
      </CalendarMonth>
      <Arrow
        onClick={props.handleNextMonth}
        title="Next Month"
      >
        <Icon icon="calendar-next-month-icon" />
      </Arrow>
    </CalendarHeaderWrapper>
  )
}

CalendarHeader.propTypes = {
  handlePreviousMonth: PropTypes.func,
  handleNextMonth: PropTypes.func
};

export default CalendarHeader;


// WEBPACK FOOTER //
// ./src/components/UI/DateSelector/CalendarHeader.js